import { useState } from "react";
import { createPortal } from "react-dom";
import axios from "axios";
import { toast } from "react-toastify";

const API = "https://backend.smpn1kamal.sch.id/api";

export default function ChangePasswordModal({ token, onClose }) {
  const [form, setForm] = useState({ oldPassword: "", newPassword: "" });
  const [showOld, setShowOld] = useState(false);
  const [showNew, setShowNew] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.oldPassword || !form.newPassword) {
      return toast.error("Semua field wajib diisi");
    }
    try {
      await axios.put(`${API}/change-password`, form, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success("Kata sandi berhasil diubah");
      onClose();
    } catch (err) {
      toast.error(err.response?.data?.message || "Gagal mengubah sandi");
    }
  };

  const EyeIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
    </svg>
  );

  const EyeOffIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
    </svg>
  );

  return createPortal(
    <div
      className="fixed inset-0 bg-slate-900/60 backdrop-sm flex items-center justify-center z-[9999] p-4"
      onClick={onClose}
    >
      <form
        onSubmit={handleSubmit}
        onClick={(e) => e.stopPropagation()}
        className="bg-white w-full max-w-md rounded-2xl shadow-2xl overflow-hidden"
      >
        {/* HEADER */}
        <div className="px-6 py-4 border-b bg-gray-50">
          <h2 className="text-lg font-semibold text-slate-800">Ubah kata sandi</h2>
          <p className="text-xs text-slate-400 mt-1">
            Pastikan kata sandi baru aman dan mudah diingat
          </p>
        </div>

        {/* FORM */}
        <div className="px-6 py-5 space-y-4">

          {/* Kata sandi lama */}
          <div>
            <label className="label">Kata sandi lama</label>
            <div className="relative">
              <input
                type={showOld ? "text" : "password"}
                placeholder="Masukkan kata sandi lama"
                className="input pr-9"
                autoComplete="current-password"
                onChange={(e) => {
                  setForm({ ...form, oldPassword: e.target.value });
                  if (e.target.value === "") setShowOld(false);
                }}
              />
              {form.oldPassword.length > 0 && (
                <button
                  type="button"
                  onClick={() => setShowOld((prev) => !prev)}
                  tabIndex={-1}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                >
                  {/* Mata TERBUKA saat terlihat, TERTUTUP saat tersembunyi */}
                  {showOld ? <EyeIcon /> : <EyeOffIcon />}
                </button>
              )}
            </div>
          </div>

          {/* Kata sandi baru */}
          <div>
            <label className="label">Kata sandi baru</label>
            <div className="relative">
              <input
                type={showNew ? "text" : "password"}
                placeholder="Masukkan kata sandi baru"
                className="input pr-9"
                autoComplete="new-password"
                onChange={(e) => {
                  setForm({ ...form, newPassword: e.target.value });
                  if (e.target.value === "") setShowNew(false);
                }}
              />
              {form.newPassword.length > 0 && (
                <button
                  type="button"
                  onClick={() => setShowNew((prev) => !prev)}
                  tabIndex={-1}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                >
                  {/* Mata TERBUKA saat terlihat, TERTUTUP saat tersembunyi */}
                  {showNew ? <EyeIcon /> : <EyeOffIcon />}
                </button>
              )}
            </div>
          </div>

        </div>

        {/* ACTION */}
        <div className="flex justify-end gap-2 px-6 py-4 border-t bg-gray-50">
          <button type="button" onClick={onClose} className="btn-secondary">Batal</button>
          <button type="submit" className="btn-primary bg-red-600 hover:bg-red-700">Simpan</button>
        </div>

        <style>{`
          input::-ms-reveal,
          input::-ms-clear {
            display: none !important;
          }
          .label {
            display: block;
            font-size: 12px;
            font-weight: 600;
            color: #64748b;
            margin-bottom: 4px;
            margin-left: 4px;
            text-transform: uppercase;
          }
          .input {
            width: 100%;
            border: 1px solid #e2e8f0;
            padding: 10px;
            border-radius: 12px;
            outline: none;
          }
          .input:focus {
            box-shadow: 0 0 0 2px #ef4444;
          }
          .btn-primary {
            color: white;
            padding: 10px 16px;
            border-radius: 12px;
          }
          .btn-secondary {
            color: #475569;
            padding: 10px 16px;
            border-radius: 12px;
          }
        `}</style>
      </form>
    </div>,
    document.body
  );
}